var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'c-button c:row-center',
    _vm.type,
    _vm.primary ? 'primary' : undefined,
    _vm.disabled ? 'disabled' : undefined,
    _vm.small ? 'small' : undefined,
    _vm.large ? 'large' : undefined,
    _vm.loading ? 'loading' : undefined,
  ],on:{"click":_vm.throttledOnClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }